import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormUnifiedPersonSelectionDrawerManagerContent from './Content'
import CustomFormUnifiedPersonSelectionDrawerManagerProvider from './contexts/CustomFormUnifiedPersonSelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormUnifiedPersonSelectionDrawer: FC<Props> = ({ question, questionKey, disabled }) => {
  return (
    <CustomFormUnifiedPersonSelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormUnifiedPersonSelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormUnifiedPersonSelectionDrawerManagerProvider>
  )
}

export default CustomFormUnifiedPersonSelectionDrawer
